import { IBusinessType } from '@/models/business';

enum EFeatureRouteName {
  BRANDED_COIN = 'coin_image',
  EMAIL_AUTOMATION = 'settings-activation-emails',
  INVITE_CUSTOMER = 'customer-import',
  OFFER_COINS = 'special-coins-offers',
  WELCOME_COINS = 'offer-welcome-coins',
  REFERRAL_PROGRAM = 'referral-program',
  REWARDS_PROGRAM = 'program-status',
  SELL_COINS = 'sell_coins',
  SOCIAL_MEDIA_ASSETS = 'marketingCenter',
  SOCIAL_REWARDS = 'social-rewards'
}

const principalOrdering = {
  [EFeatureRouteName.REFERRAL_PROGRAM]: 1,
  [EFeatureRouteName.INVITE_CUSTOMER]: 2,
  [EFeatureRouteName.EMAIL_AUTOMATION]: 3,
  [EFeatureRouteName.WELCOME_COINS]: 4,
  [EFeatureRouteName.SOCIAL_REWARDS]: 5,
  [EFeatureRouteName.SELL_COINS]: 6,
  [EFeatureRouteName.OFFER_COINS]: 7,
  [EFeatureRouteName.SOCIAL_MEDIA_ASSETS]: 8,
  [EFeatureRouteName.REWARDS_PROGRAM]: 9,
  [EFeatureRouteName.BRANDED_COIN]: 10
};

const inStoreBlockedOrdering = {
  [EFeatureRouteName.OFFER_COINS]: 1,
  [EFeatureRouteName.SELL_COINS]: 2,
  [EFeatureRouteName.WELCOME_COINS]: 3,
  [EFeatureRouteName.SOCIAL_MEDIA_ASSETS]: 4,
  [EFeatureRouteName.REWARDS_PROGRAM]: 5,
  [EFeatureRouteName.BRANDED_COIN]: 6,
  [EFeatureRouteName.SOCIAL_REWARDS]: 7,
  [EFeatureRouteName.REFERRAL_PROGRAM]: 8,
  [EFeatureRouteName.INVITE_CUSTOMER]: 9,
  [EFeatureRouteName.EMAIL_AUTOMATION]: 10
};

const onlineBlockedOrdering = {
  [EFeatureRouteName.OFFER_COINS]: 1,
  [EFeatureRouteName.SELL_COINS]: 2,
  [EFeatureRouteName.SOCIAL_MEDIA_ASSETS]: 3,
  [EFeatureRouteName.REWARDS_PROGRAM]: 4,
  [EFeatureRouteName.BRANDED_COIN]: 5,
  [EFeatureRouteName.REFERRAL_PROGRAM]: 6,
  [EFeatureRouteName.INVITE_CUSTOMER]: 7,
  [EFeatureRouteName.EMAIL_AUTOMATION]: 8,
  [EFeatureRouteName.WELCOME_COINS]: 9,
  [EFeatureRouteName.SOCIAL_REWARDS]: 10
};

const disclaimerOrdering = {
  [EFeatureRouteName.REFERRAL_PROGRAM]: 1,
  [EFeatureRouteName.INVITE_CUSTOMER]: 2,
  [EFeatureRouteName.EMAIL_AUTOMATION]: 3,
  [EFeatureRouteName.WELCOME_COINS]: 4,
  [EFeatureRouteName.SOCIAL_REWARDS]: 5,
  [EFeatureRouteName.OFFER_COINS]: 6,
  [EFeatureRouteName.SELL_COINS]: 7,
  [EFeatureRouteName.SOCIAL_MEDIA_ASSETS]: 8,
  [EFeatureRouteName.REWARDS_PROGRAM]: 9,
  [EFeatureRouteName.BRANDED_COIN]: 10
};

const online = {
  principal: principalOrdering,
  blocked: onlineBlockedOrdering
};

const inStore = {
  principal: principalOrdering,
  blocked: inStoreBlockedOrdering
};

export const orderFeatures: {
  [key: string]: any;
} = {
  [IBusinessType.ONLINE]: online,
  [IBusinessType.INSTORE]: inStore,
  [IBusinessType.BOTH]: inStore,
  disclaimer: disclaimerOrdering
};
